// client/src/components/shared/constants/symptoms.js
// Central symptomlista (svenska) som används genom hela appen.

export const ALL_SYMPTOMS = [
  'Andfåddhet',
  'Andningssvårigheter',
  'Aptitlöshet',
  'Bröstsmärta',
  'Diarré',
  'Feber',
  'Frossa',
  'Halsont',
  'Hosta',
  'Hudutslag',
  'Huvudvärk',
  'Illamående',
  'Kliande ögon',
  'Kräkningar',
  'Ledvärk',
  'Magont',
  'Muskelvärk',
  'Nysningar',
  'Nästäppa',
  'Snuva',
  'Svettningar',
  'Trötthet',
  'Yrsel'
];

/**
 * Vanligaste symptomen (för kompakt visning)
 */
export const COMMON_SYMPTOMS = [
  'Feber',
  'Hosta', 
  'Huvudvärk',
  'Halsont',
  'Trötthet',
  'Snuva',
  'Muskelvärk',
  'Illamående',
  'Magont',
  'Frossa'
];

/**
 * Färgkodning per symptom
 */
export const SYMPTOM_COLORS = {
  'Feber': '#e74c3c',
  'Hosta': '#3498db',
  'Huvudvärk': '#9b59b6',
  'Halsont': '#f39c12',
  'Trötthet': '#2ecc71',
  'Andningssvårigheter': '#e67e22',
  'Andfåddhet': '#e67e22',
  'Muskelvärk': '#8e44ad',
  'Frossa': '#16a085',
  'Illamående': '#1abc9c',
  'Diarré': '#d35400',
  'Yrsel': '#c0392b',
  'Bröstsmärta': '#c0392b',
  'Magont': '#27ae60',
  'Snuva': '#2980b9',
  'Kräkningar': '#d35400',
  'Ledvärk': '#8e44ad',
  'Hudutslag': '#e91e63',
  'Svettningar': '#00bcd4',
  'Nästäppa': '#2980b9',
  'Nysningar': '#3498db',
  'Kliande ögon': '#9c27b0',
  'Aptitlöshet': '#607d8b'
};

/**
 * Hämta färg för ett symptom
 * @param {string} symptomName - Symptomets namn
 * @returns {string} - Hex färgkod
 */
export const getSymptomColor = (symptomName) => {
  return SYMPTOM_COLORS[symptomName] || '#95a5a6';
};

/**
 * Exportera default för enkel import
 */
export default {
  ALL_SYMPTOMS,
  COMMON_SYMPTOMS,
  SYMPTOM_COLORS,
  getSymptomColor
};
